import { render, staticRenderFns } from "./MerchantLabel.vue?vue&type=template&id=5b006164"
import script from "./MerchantLabel.vue?vue&type=script&lang=js"
export * from "./MerchantLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports